module.exports = __webpack_public_path__ + "static/image4-0c81cf55bddb1c325cc555eb0a7eb5f1.png";